<div
  class="icon-container"
  (click)="toggleMenuItems()"
>
  <span
    class="icon"
    [ngClass]="{'open': showMenuItems}"
  >
    <span></span>
    <span></span>
    <span></span>
    <span></span>
  </span>
</div>
